import styled from "styled-components"
import { bp } from "../breakpoints"

export const Wrapper = styled.section`
  background-color: #F4F4F4;
  padding: 4rem 2rem;

  .header {
    text-align: center;
    margin-bottom: 3rem;

    h2 {
      color: ${({ theme }) => theme.colors.azul};
      font-size: 70px;
      font-weight: 300;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      margin: 0 0 0.5rem;

      @media ${bp.l} {
        font-size: 56px;
      }
      @media ${bp.m} {
        font-size: 35px;
      }
    }

    p {
      color: #636363;
      font-size: 23px;
      font-weight: 400;
      line-height: 1.4;
      max-width: 600px;
      margin: 0 auto;

      @media ${bp.l} {
        font-size: 19px;
      }
      @media ${bp.m} {
        width: 70%;
      }
      @media ${bp.s} {
        font-size: 16px;
        width: 60%;
      }
      @media ${bp.xs} {
        width: 90%;
      }
    }
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;

    @media ${bp.m} {
      padding: 0 1rem;
    }
  }

  .card {
    background-color: transparent;
    border: 2px solid ${({ theme }) => theme.colors.amarillo};
    border-radius: 15px;
    padding: 2.5rem 3rem;

    .card__icon {
      width: 60px;
      height: 60px;
      margin-bottom: 1rem;
    }

    h3 {
      color: ${({ theme }) => theme.colors.azul};
      font-size: 35px;
      font-weight: 300;
      margin: 0 0 0.8rem;
      text-transform: uppercase;
      letter-spacing: 0.03em;

      @media ${bp.l} {
        font-size: 30px;
      }
      @media ${bp.m} {
        font-size: 25px;
      }
    }

    p {
      color: #454545;
      font-size: 20px;
      font-weight: 400;
      line-height: 1.4;
      margin: 0;

      @media ${bp.l} {
        font-size: 19px;
      }
      @media ${bp.s} {
        font-size: 16px;
      }
    }
  }

  @media ${bp.m} {
    .grid {
      grid-template-columns: repeat(2, 1fr);
    }
    .card:last-child {
      grid-column: 1 / -1;
      max-width: calc(50% - 1rem);
      margin: 0 auto;
      width: 100%;
    }
  }
  @media ${bp.s} {
    .grid {
      grid-template-columns: 1fr;
    }
    .card:last-child {
      max-width: 100%;
    }
  }
`
